export default function Switch({ checked, onChange, label, disabled = false }) {
    const handleChange = (e) => {
        onChange(e.target.checked);
    };

    return (
        <label className="flex items-center cursor-pointer">
            <div className="relative">
                <input
                    type="checkbox"
                    className="sr-only"
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                />
                <div
                    className={`block w-10 h-6 rounded-full transition-colors ${checked
                        ? 'bg-foreground-light dark:bg-foreground-dark'
                        : 'bg-border-light dark:bg-border-dark'
                        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                />
                <div
                    className={`absolute left-1 top-1 bg-background-light dark:bg-background-dark w-4 h-4 rounded-full transition-transform ${checked ? 'transform translate-x-4' : ''
                        }`}
                />
            </div>
            {label && (
                <span className="ml-3 text-sm font-medium">
                    {label}
                </span>
            )}
        </label>
    );
}

